import React from 'react';
import cn from 'clsx';
import { ButtonWithGAClickButton, Typography } from 'common/components';
import {
  descriptionBlock,
  easyItem,
  header,
  headerContent,
  headerSection,
  itemText,
  list,
  listItem,
  rangeItem,
  seeAllButton,
  smallText,
  textWrapper,
  varietyItem,
  video,
  qualityItem,
} from './header-section-styles';

/**
 * Вью секции с заголовком
 */
export const HeaderSection = () => (
  <section className={headerSection}>
    <div className={textWrapper}>
      <Typography variant="display" as="h1" className={header}>
        <span className={smallText}>Многофункциональная система хранения </span>Spaceo KUB
      </Typography>
      <Typography variant="l" size="body_short">
        Используйте для хранения, зонирования и&nbsp;декорирования пространства.
      </Typography>
      <Typography variant="l" size="body_short">
        Более 200 вариантов комбинаций
      </Typography>
    </div>

    <div className={headerContent}>
      <video
        className={video}
        title="Многофункциональная система хранения Spaceo KUB"
        controls
        autoPlay
        muted>
        <source
          src="https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252Fspaceo.mp4/spaceo.mp4"
          type="video/mp4"
        />
      </video>
      <div className={descriptionBlock}>
        <ul className={list}>
          <li className={cn(listItem, varietyItem)}>
            <Typography variant="l" size="body_short" className={itemText}>
              Вариативность: различные цвета, формы и&nbsp;аксессуары
            </Typography>
          </li>
          <li className={cn(listItem, qualityItem)}>
            <Typography variant="l" size="body_short" className={itemText}>
              Высокое качество по&nbsp;доступной цене
            </Typography>
          </li>
          <li className={cn(listItem, easyItem)}>
            <Typography variant="l" size="body_short" className={itemText}>
              Простота сборки
            </Typography>
          </li>
          <li className={cn(listItem, rangeItem)}>
            <Typography variant="l" size="body_short" className={itemText}>
              Многообразие вариантов применения
            </Typography>
          </li>
        </ul>

        <ButtonWithGAClickButton
          className={seeAllButton}
          elementBlock="landingSpaceoKub"
          elementName="Многофункциональная система хранения Spaceo Kub"
          elementText="Смотреть все товары"
          href="/catalogue/stellazhi-dlya-doma/spaceo/"
          title="Смотреть все товары"
          wide>
          Смотреть все товары
        </ButtonWithGAClickButton>
      </div>
    </div>
  </section>
);
